import { Alert, AlertTitle, Skeleton } from "@mui/material";

import { RobotoDomainException } from "@/shared/http/exceptions";
import { randomInt } from "@/shared/math";

import styles from "./DatasetList.module.css";

/**
 * Loading fallback for DatasetList Suspense boundary
 */
export function DatasetListLoading() {
  return (
    <div className={styles.loadingContainer}>
      {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
        <div key={i} className={styles.skeletonItem}>
          <div className={styles.title}>
            <Skeleton
              animation="wave"
              variant="text"
              width={randomInt(100, 300)}
            />
          </div>
          <div className={styles.subtitle}>
            <Skeleton animation="wave" variant="text" width="150px" />
            <Skeleton animation="wave" variant="text" width="100px" />
          </div>
        </div>
      ))}
    </div>
  );
}

/**
 * Error fallback for DatasetList Error Boundary
 */
export function DatasetListError({ error }: { error: Error }) {
  function getErrorMessage(error: Error) {
    if (error instanceof RobotoDomainException && error.isClientError()) {
      return error.message;
    }
    return "Something went wrong. Please try closing and reopening the file picker.";
  }

  return (
    <div className={styles.errorContainer}>
      <Alert severity="error">
        <AlertTitle>Failed to load datasets</AlertTitle>
        {getErrorMessage(error)}
      </Alert>
    </div>
  );
}
